import { PluginIdentifierEnum, PluginStatusEnum } from 'api/enums';
import { immerable } from 'immer';
import { IUserModel } from './user.model';

/* -------------------------------------------------------------------------------------------------
 * IPublicApiModel
 * -----------------------------------------------------------------------------------------------*/

export interface IPublicApiModel {
    _id: string;
    url: string;
    status: PluginStatusEnum;
    title: string;
    user: IUserModel;
    regeneratedBy: IUserModel;
    apiKey: string;
    apiSecret: string;
    vendor: PluginIdentifierEnum;
}

/* -------------------------------------------------------------------------------------------------
 * PublicApiModel
 * -----------------------------------------------------------------------------------------------*/

export class PublicApiModel {
    [immerable] = true;

    _id: string;
    url: string;
    status: PluginStatusEnum;
    title: string;
    user: IUserModel;
    regeneratedBy: IUserModel;
    apiKey: string;
    apiSecret: string;
    vendor: PluginIdentifierEnum;

    constructor(data: Partial<IPublicApiModel>) {
        this._id = data._id || '';
        this.url = data.url ?? '';
        this.status = data.status ?? null;
        this.title = data.title ?? '';
        this.user = data.user;
        this.regeneratedBy = data.regeneratedBy;
        this.apiKey = data.apiKey ?? '';
        this.apiSecret = data.apiSecret ?? '';
        this.vendor = data.vendor;
    }

    static fromObject(data: Partial<IPublicApiModel>): PublicApiModel {
        const model = new PublicApiModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IPublicApiModel>[]): PublicApiModel[] {
        return data.map((row) => PublicApiModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IPublicApiModel>): PublicApiModel {
        const model = new PublicApiModel(data);

        return model;
    }

    toObject(): IPublicApiModel {
        const data: IPublicApiModel = {
            _id: this._id,
            url: this.url,
            status: this.status,
            title: this.title,
            user: this.user,
            regeneratedBy: this.regeneratedBy,
            apiKey: this.apiKey,
            apiSecret: this.apiSecret,
            vendor: this.vendor,
        };

        return data;
    }
}
